function main() {
    return (
      <div className="min-h-screen flex items-center justify-center p-8 bg-white">
        <h2 className="text-2xl font-bold">Pesquisar Candidatos</h2>
      </div>
    );
  }
  
  export default main;
  